import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import chatify from "../../Assets/Projects/chatify.png";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />

      <Container>
        <h1 className="project-heading">
          My <strong className="purple">Projects</strong>
        </h1>

        <p style={{ color: "white" }}>
          Here are some of the projects I’ve built while developing my skills
          in software engineering.
        </p>

        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={chatify}
              isBlog={false}
              title="Mini RAG Demo"
              description="A full-stack RAG application built with Flask. The project supports document uploading and chat-based interaction through REST APIs, with a focus on backend services, document processing, and AI application architecture."
              ghLink="YOUR_GITHUB_LINK"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={chatify}
              isBlog={false}
              title="Personal Portfolio"
              description="A responsive personal portfolio website built with React. It showcases my background, technical skills, projects, and experience while giving me hands-on experience with frontend development and web deployment."
              ghLink="YOUR_GITHUB_LINK"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={chatify}
              isBlog={false}
              title="Cloud-Based Web Application"
              description="A cloud-based web application focused on AWS infrastructure, frontend and backend integration, APIs, and deployment of modern web applications."
              ghLink="YOUR_GITHUB_LINK"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={chatify}
              isBlog={false}
              title="Backend API Project"
              description="A backend application designed to practice REST API development, database integration, authentication, and backend architecture using Python and modern web frameworks."
              ghLink="YOUR_GITHUB_LINK"
            />
          </Col>

        </Row>
      </Container>
    </Container>
  );
}

export default Projects;